
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M29.135 6.29H7.973l.342 18.603 18.206 18.43h11.431V15.108h-8.817z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M13.264 20.506V1h20.28l9.698 9.699v27.333h-16.07"}}),_c('path',{attrs:{"stroke":"#234652","d":"M31.305 1.605v9.557h9.557"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M4.414 47h20.807L4.414 26.193z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M8.517 25.648v16.905h16.905M23.92 26.843 8.776 42.258"}})])
          )
        }
      }
    